import { styled } from "@material-ui/core";
import { DragNDropUpload, Flex, FormSelect, Option, SelectFile, div, span } from "lqx-react";
import * as React from "react";
import { useEffect } from "react";

export const UploadSection = ({ $file, $delimiter, isValidFile }: { $file, $delimiter, isValidFile }) => {
    useEffect(() => {
        if ($file.value && $file.value.name.split('.').pop() === 'csv') {
            $delimiter.set(',');
        }
    }, [$file.value]);

    return (
        <UploadContainer>
            {$file.value && !isValidFile && <UploadWarning>Your file is in incorrect format</UploadWarning>}
            <DragNDropUpload $file={$file} />
            {$file.value &&
                <Flex column center>
                    <UploadedFileName>{$file.value.name}</UploadedFileName>
                </Flex>}
            <Flex column center>
                <span>Drag and drop here or <UploadSelectFile label="select a file" $value={$file} /> to upload your Templates</span>
            </Flex>
            {$file.value && ($file.value.name.split('.').pop() === 'csv' || $file.value.name.split('.').pop() === 'txt') &&
                <Flex column center>
                    <DelimiterLabel>Delimiter</DelimiterLabel>
                    <StateFilterSelect $value={$delimiter}>
                        <Option value="*">*</Option>
                        <Option value="~">~</Option>
                        <Option value="|">|</Option>
                        <Option value=",">,</Option>
                        <Option value=";">;</Option>
                    </StateFilterSelect>
                </Flex>
            }
        </UploadContainer>
    );
};

const UploadContainer = div({
    backgroundColor: 'white',
    padding: '30px'
});

const UploadedFileName = div({
    color: '#4197d6',
    fontWeight: 800
});

const UploadWarning = div({
    marginTop: '15px',
    color: '#fccb4f'
});

const UploadSelectFile = styled(SelectFile)({
    border: 'none',
    display: 'inline-block',
    padding: 0,
    '& .filename': {
        display: 'none'
    },
    '& .MuiSvgIcon-root': {
        display: 'none'
    },
    '& div': {
        color: '#4197d6',
        fontSize: 15
    },
    cursor: 'pointer'
});

const DelimiterLabel = span({
    color: '#767D84',
    fontSize: '12px',
    marginRight: '10px'
});

const StateFilterSelect = styled(FormSelect)({
    width: '200px',
    borderRadius: '4px',
    '& .MuiSelect-root': {
        borderRadius: '4px',
    },
    '& .MuiSelect-icon': {
        top: 'calc(50% - 9px)'
    }
});